import type { OwnerStateThemeType } from '.';
import { lighten as muiLighten, darken as muiDarken } from '@mui/material/styles';
import type { Settings } from '../../context/settingsContext';

const AppBar = (settings: Settings) => {
  const light = settings.mode === 'light';
  const darken = light ? muiDarken : muiLighten;
  const backdropFilter =
    settings.backgroundFilter && settings.backgroundFilter !== 'none'
      ? settings.backgroundFilter
      : undefined;

  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backdropFilter,
          borderTop: 'none',
          borderRight: 'none',
          borderLeft: 'none',
          backgroundImage: 'none',
        },
        colorDefault:
          settings.skin === 'bordered'
            ? undefined
            : ({ theme }: OwnerStateThemeType) => ({
                backgroundColor: `${darken(theme.palette.background.paper, 0.02)} !important`,
              }),
      },
    },
  };
};

export default AppBar;
